import {
  LogisticsCalculationPublicDtoSchema,
  type LogisticsCalculationPublicDto,
} from '@magimp/shared';

const PUBLIC_BASE = '/api/public/logistics-calculations';

export class PublicLogisticsCalculationNotFoundError extends Error {
  constructor() {
    super('public-logistics-calculation-not-found');
    this.name = 'PublicLogisticsCalculationNotFoundError';
  }
}

function post(action: 'resolve', body: unknown): Promise<Response> {
  return fetch(`${PUBLIC_BASE}/${action}`, {
    method: 'POST',
    credentials: 'omit',
    cache: 'no-store',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function resolvePublicLogisticsCalculation(
  token: string,
): Promise<LogisticsCalculationPublicDto> {
  try {
    const response = await post('resolve', { token });
    if (!response.ok) throw new PublicLogisticsCalculationNotFoundError();
    return LogisticsCalculationPublicDtoSchema.parse(await response.json());
  } catch {
    throw new PublicLogisticsCalculationNotFoundError();
  }
}

export function parsePublicLogisticsCalculationToken(hash: string): string | null {
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  return params.get('t') || null;
}
